<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" 
               [mode]="isHandset ? 'over' : 'side'"
               [opened]="!isHandset && showSidebarAndProfile"
               [fixedInViewport]="isHandset"
               [attr.role]="'navigation'"
               *ngIf="showSidebarAndProfile">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink="/playlists" (click)="onMenuItemClick()">
        <mat-icon>library_music</mat-icon>
        <span>Playlists</span>
      </a>
      <a mat-list-item routerLink="/ai-playlists" (click)="onMenuItemClick()">
        <mat-icon>auto_awesome</mat-icon>
        <span>AI Playlists</span>
      </a>
      <a mat-list-item routerLink="/listening-history" (click)="onMenuItemClick()">
        <mat-icon>history</mat-icon>
        <span>Listening History</span>
      </a>

      <mat-divider></mat-divider>
      
      <div class="quick-play-section" *ngIf="isAuthenticated">
        <app-quick-play-panel></app-quick-play-panel>
      </div>
    </mat-nav-list>
  </mat-sidenav>
  
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button type="button" 
              mat-icon-button 
              (click)="drawer.toggle()"
              *ngIf="isHandset && showSidebarAndProfile">
        <mat-icon>menu</mat-icon>
      </button>
      <span>{{ title }}</span>
      <span class="toolbar-spacer"></span>
      
      <!-- Voice Commands button for simple view -->
      <button mat-icon-button 
              (click)="openVoiceCommands()"
              *ngIf="viewState.isSimpleView && isAuthenticated"
              matTooltip="Voice Commands"
              class="voice-command-btn">
        <mat-icon>mic</mat-icon>
      </button>
      
      <!-- View Toggle button -->
      <button mat-icon-button 
              (click)="toggleView()"
              *ngIf="isAuthenticated"
              [matTooltip]="viewState.isSimpleView ? 'Switch to Full View' : 'Switch to Simple View'"
              class="view-toggle-btn">
        <mat-icon>{{ viewState.isSimpleView ? 'view_compact' : 'view_agenda' }}</mat-icon>
      </button>

      <!-- Report Bug button -->
      <button mat-icon-button
              (click)="openBugReport()"
              *ngIf="isAuthenticated"
              matTooltip="Report Bug"
              class="report-bug-btn">
        <mat-icon>bug_report</mat-icon>
      </button>

      <button mat-icon-button (click)="themeService.toggleTheme()" [attr.aria-label]="'Toggle ' + (themeService.isDarkMode ? 'light' : 'dark') + ' mode'">
        <mat-icon>{{ themeService.isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>
      <app-profile-mini-card *ngIf="isAuthenticated && showSidebarAndProfile"></app-profile-mini-card>
    </mat-toolbar>
    
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
    
    <!-- Floating Player Widget -->
    <app-floating-player></app-floating-player>

    <div class="app-version">{{ version }}</div>
  </mat-sidenav-content>
</mat-sidenav-container>